<script>
  import { apiFetch } from "../lib/api.js";
  import { user } from "../stores/user"
  import { BASE_URL } from "../stores/BASE_URL"
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import Navbar from "../components/Navbar.svelte"
  import makeid from "../services/makeid.js"
  import Alert from "../components/Alert.svelte"
  import CardContent from "../components/CardContent.svelte"

  let clientes = []
  let usuarios = []
  let cliente = "0"
  let estado = 1
  let sms = false
  let correo = false
  let isSeting = false
  let select = true

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 5000,
  }

  const getClientes = async () => {
    const response = await apiFetch(`${BASE_URL}cliente.php?action=getClientes`)
    const resp = await response.json()
    clientes = resp.data
    if (clientes.length > 0) {
      cliente = clientes[0].id
    }
  }

  const getUsuarios = async () => {
    const response = await apiFetch(
      `${BASE_URL}usuario.php?action=getUsuarios&id_cliente=${cliente}&estado_activo=${estado}`,
    )
    const resp = await response.json()
    let tmp_usuarios = resp.data
    return tmp_usuarios
  }

  const handleGenerar = async () => {
    let tmp_usuarios = await getUsuarios()
    let tmp_usuarios_nuevos = []
    for (let usuario of tmp_usuarios) {
      tmp_usuarios_nuevos.push({
        id: usuario.id,
        usuario: usuario.usuario,
        celular: usuario.celular,
        celular_codigo: usuario.celular_codigo,
        clave: makeid(10),
        select: true,
      })
    }
    usuarios = tmp_usuarios_nuevos
  }

  const handleGuardar = async () => {
    isSeting = true

    let post_data = {
      action: "setClaves",
      data: {
        id_cliente: cliente,
        session_id_usuario: $user.idUsuario,
        usuarios: usuarios.filter((usuario) => usuario.select),
        sms: sms ? "SI" : "NO",
        correo: correo ? "SI" : "NO",
      },
    }
    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: JSON.stringify(post_data),
    })
    const resp = await response.json()
    if (resp.status == "success") {
      alert.show = true
      alert.message = "Datos actualizados"
      alert.status = "success"
    } else {
      alert.show = true
      alert.message = "Error al actualizar los datos"
      alert.status = "danger"
    }
    isSeting = false
  }

  const validarNumeroCelular = (codigo, celular) => {
    const numero = String(celular).replace(/\D/g, "")

    const regexPeru = /^9\d{8}$/ // 9 dígitos, empieza con 9
    const regexMexico = /^\d{10}$/ // 10 dígitos

    if (codigo === "51") {
      return regexPeru.test(numero)
    }

    if (codigo === "52") {
      return regexMexico.test(numero)
    }

    return false
  }

  const validarCorreo = (correo = "") => {
    const email = correo.trim()

    const regexCorreo =
      /^(?!\.)(?!.*\.\.)(?!.*\.@)[A-Z0-9._%+-]+@(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,}$/i

    return regexCorreo.test(email)
  }

  const selectAll = () => {
    usuarios = usuarios.map((usuario) => {
      return { ...usuario, select: select }
    })
  }

  getClientes()

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }
  })
</script>

{#if $user}
  <Navbar />

  <div class="container-fluid py-3">
    <CardContent title="Cambiar contraseñas">
      <div class="row align-items-center g-2">
        <div class="col-12 col-xl-6">
          <label for="cliente">Cliente</label>
          <select class="form-select" id="cliente" bind:value={cliente}>
            {#each clientes as cliente}
              <option value={cliente.id}>{cliente.razon_social}</option>
            {/each}
          </select>
        </div>

        <div class="col-12 col-xl-6">
          <div class="d-flex gap-2 aling-items-center justify-content-end">
            <div class="form-check d-flex align-items-center">
              <input
                class="form-check-input me-1"
                type="checkbox"
                bind:checked={correo}
                id="correo"
              />
              <label class="form-check-label me-2" for="correo">
                Enviar Correo
              </label>
            </div>
            <div class="form-check d-flex align-items-center">
              <input
                class="form-check-input me-1"
                type="checkbox"
                bind:checked={sms}
                id="sms"
              />
              <label class="form-check-label me-2" for="sms">
                Enviar SMS
              </label>
            </div>
            <button class="btn btn-primary" on:click={handleGenerar}
              >Generar Contraseñas</button
            >
            <button
              class="btn btn-primary"
              on:click={handleGuardar}
              disabled={usuarios.length == 0 || isSeting}>Guardar</button
            >
          </div>
        </div>
      </div>

      <div class="table-responsive my-2">
        <table class="table table-bordered table-sm table-striped small">
          <thead>
            <tr class="text-secondary fw-normal">
              <th>Usuario</th>
              <th>Celular</th>
              <th>Contraseña</th>
              <th class="text-center"
                >Seleccionar <input
                  type="checkbox"
                  class="form-check-input"
                  bind:checked={select}
                  on:change={selectAll}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {#each usuarios as usuario}
              <tr>
                <td
                  class:table-danger={!validarCorreo(usuario.usuario) && correo}
                  >{usuario.usuario}</td
                >
                <td
                  class:table-danger={!validarNumeroCelular(
                    usuario.celular_codigo,
                    usuario.celular,
                  ) && sms}
                  >{usuario.celular != ""
                    ? usuario.celular_codigo + " " + usuario.celular
                    : ""}</td
                >
                <td>{usuario.clave}</td>
                <td class="text-center">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    bind:checked={usuario.select}
                    on:change={(e) => {
                      usuarios = usuarios.map((u) =>
                        u.id === usuario.id
                          ? { ...u, select: e.currentTarget.checked }
                          : u,
                      )
                    }}
                  />
                </td></tr
              >
            {:else}
              <tr>
                <td colspan="4" class="text-center text-secondary"
                  >· · · No se encontraron resultados · · ·</td
                >
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </CardContent>
    <br />
    {#if alert.show}
      <Alert message={alert.message} status={alert.status} time={alert.time} />
    {/if}
  </div>
{/if}
